const parseData = (param, precision = 0) => {
  if (param === null || param === undefined || param === '') return '0'
  if (param === 'N/a' || (typeof param === 'string' && param.toLowerCase() === 'n/a')) return 'N/a'
  const num = parseFloat(param)
  if (isNaN(num)) return 'N/a'
  return num.toLocaleString('en-US', { maximumFractionDigits: precision })
}

export default parseData
